/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-02 20:35:01
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-03 14:39:46
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Col,
  Modal,
  Row,
  Tag,
  Cascader as Cascaded,
  Checkbox,
  notification,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { getReplaceTcmItemAsync } from '../recipeListEditorSlice'

export const ChangeElseFactorModal = (props: {
  showFlag?: any
  dataList?: any
  visible?: any
  onCancel: () => void
  onOk: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [isLoading, setIsLoading] = useState(false)

  const [selectedItems, setSelectedItems] = useState<any>()

  const [
    packageDetailsReplacementChecked,
    setPackageDetailsReplacementChecked,
  ] = useState<any>()

  // 处理checkbox变化
  const handleCheckboxChange = (
    checked: boolean,
    parentItem: any,
    replaceItem: any
  ) => {
    setSelectedItems((prev: any) => {
      const recipeItemId = parentItem.id
      if (checked) {
        const filteredPrev = prev?.filter(
          (item: any) => item.recipeItemId !== recipeItemId
        )
        // 选中当前项，同时移除同组其他选中项
        return [
          ...filteredPrev,
          {
            recipeItemId: recipeItemId,
            replaceItem: replaceItem,
          },
        ]
      } else {
        // 取消选中，移除该组的选中项
        return prev.filter(
          (item: any) =>
            !(
              item.recipeItemId === recipeItemId &&
              item.replaceItem.tenantInventoryLedgerId ===
                replaceItem.tenantInventoryLedgerId
            )
        )
      }
    })
  }

  // 检查某个选项是否被选中
  const isItemSelected = (parentItem: any, replaceItem: any) => {
    const recipeItemId = parentItem.id
    return selectedItems?.some(
      (item: any) =>
        item.recipeItemId === recipeItemId &&
        item.replaceItem.tenantInventoryLedgerId ===
          replaceItem.tenantInventoryLedgerId
    )
  }
  useEffect(() => {
    if (!props?.visible) {
      setSelectedItems([])
    } else {
      const packageDetailsReplacementFlag = localStorage.getItem(
        'packageDetailsReplacementFlag'
      )
      setPackageDetailsReplacementChecked(
        packageDetailsReplacementFlag == '1' ? true : false
      )
      setSelectedItems(
        props?.dataList
          ?.filter((val: any) => val?.couldReplaceStockList?.length != 0)
          ?.map((v: any) => {
            return {
              recipeItemId: v?.id,
              replaceItem: v?.couldReplaceStockList?.[0],
            }
          })
      )
    }
  }, [props?.visible, props?.dataList])

  return (
    <Modal
      title={'以下药品库存不足，您可以选择其他同名品种替换'}
      visible={props?.visible}
      width={840}
      bodyStyle={{
        padding: '20px 30px 20px 15px',
        height: '540px',
        overflow: 'auto',
      }}
      style={{ position: 'relative' }}
      confirmLoading={isLoading}
      onCancel={(e) => {
        setSelectedItems([])
        props?.onCancel && props?.onCancel()
      }}
      onOk={(e) => {
        if (selectedItems.length === 0) {
          notification.info({
            message: '请至少选择一个替换项',
          })
          return
        } else {
          setIsLoading(true)
          dispatch(
            getReplaceTcmItemAsync({
              asyncToCombo: packageDetailsReplacementChecked ? 1 : 0,
              data: selectedItems,
            })
          )
            .then(unwrapResult)
            .then((v: any) => {
              notification.success({
                message: '操作成功',
              })
              setSelectedItems([])
              props?.onOk && props?.onOk()
            })
            .finally(() => {
              setIsLoading(false)
            })
        }
      }}
    >
      <div>
        {props?.dataList?.map((v: any, index: any) => {
          return (
            <Col key={index} style={{ borderBottom: '1px solid ##EEEEEE' }}>
              {v?.couldReplaceStockList?.length ? (
                <Row style={{ lineHeight: '34px', fontWeight: 'bold' }}>
                  {v?.name}
                </Row>
              ) : (
                <></>
              )}

              {v?.couldReplaceStockList?.map((t: any, index: any) => {
                return (
                  <Row
                    key={t?.tenantInventoryLedgerId}
                    style={{ marginLeft: '10px', lineHeight: '34px' }}
                  >
                    <Checkbox
                      checked={isItemSelected(v, t)}
                      style={{ marginRight: '8px' }}
                      onChange={(e) => {
                        handleCheckboxChange(e.target.checked, v, t)
                      }}
                    />
                    <span style={{ marginRight: '12px' }}> {t?.name} </span>
                    <span> {t?.productInfo} </span>
                    <span style={{ color: '#427bff', marginRight: '10px' }}>
                      {t?.tenantSupplierName}
                    </span>
                    <span style={{ marginRight: '10px' }}>
                      批次: {t?.batchNo}
                    </span>
                    <span style={{ marginRight: '10px' }}>
                      库存数: {t?.count}
                      {t?.accountUnit}
                    </span>
                    <span> 库存售价: {t?.stockPrice}元</span>
                  </Row>
                )
              })}
            </Col>
          )
        })}
        {props?.showFlag ? (
          <div style={{ position: 'absolute', bottom: '4px' }}>
            <Checkbox
              checked={packageDetailsReplacementChecked}
              onChange={(v: any) => {
                setPackageDetailsReplacementChecked(v.target.checked)
                const flag = v.target.checked ? '1' : '0'
                localStorage.setItem('packageDetailsReplacementFlag', flag)
              }}
              style={{ margin: '10px 0' }}
            >
              替换后保存到原有套餐明细
            </Checkbox>
          </div>
        ) : (
          <></>
        )}
      </div>
    </Modal>
  )
}
